module.exports = __webpack_public_path__ + "img/text-file.790ab6e5.svg";